import { render, staticRenderFns } from "./DemographicsDescriptionSection.vue?vue&type=template&id=4e2c27d9&scoped=true"
import script from "./DemographicsDescriptionSection.vue?vue&type=script&lang=js"
export * from "./DemographicsDescriptionSection.vue?vue&type=script&lang=js"
import style0 from "./DemographicsDescriptionSection.vue?vue&type=style&index=0&id=4e2c27d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2c27d9",
  null
  
)

export default component.exports